/**
 * Perform a Foundation API call via Ajax.
 * @constructor
 * @param {string} method
 * @param {string} resource
 * @param {Object.<string,*>=} parameters
 * @extends {Foundation.Promise}
 */
Foundation.API = function (method, resource, parameters) {
    Foundation.Promise.call(this);

    /**
     * @private
     * @type {string}
     */
    this._apiMethod = method

    /**
     * @private
     * @type {string}
     */
    this._apiResource = resource

    /**
     * @private
     * @type {Object.<string,*>}
     */
    this._apiParameters = parameters || null

    /**
     * @private
     * @type {number?}
     */
    this._apiResponseCode = null

    /**
     * @private
     * @type {jQuery.jqXHR}
     */
    this._apiXHR = jQuery.ajax({
        "url": `/gyrobase/API/${resource}`,
        "type": this._apiMethod,
        "data": this._apiParameters,
        "dataType": "json",
        "success": this._apiHandleSuccess.bind(this),
        "error": this._apiHandleError.bind(this)
    });
};
Foundation.inherit(Foundation.API, Foundation.Promise);

/**
 * @private
 * @param {Object} jsonData
 */
Foundation.API.prototype._apiHandleSuccess = function (jsonData) {
    this._apiResponseCode = this._apiXHR.status
    this.set("__api_response_code", this._apiResponseCode)

    this.fulfillWith(jsonData);
};

/**
 * @private
 * @param {jQuery.jqXHR} xhr
 * @param {string} textStatus
 * @param {string} errorThrown
 */
Foundation.API.prototype._apiHandleError = function (xhr, textStatus, errorThrown) {
    this._apiResponseCode = this._apiXHR.status

    var contentType = "";
    if (xhr && xhr.getResponseHeader) {
        contentType = xhr.getResponseHeader("Content-Type") || "";
    }

    if (contentType.match(/\bapplication\/json\b/)) {
        let err;
        try {
            err = JSON.parse(xhr.responseText);
        }
        catch (parseError) {
            this.failWith({
              "errors":[`Sorry, an error occurred: ${parseError.message}`]
            });
        }
        if (err) this.failWith(err);
    }
    else {
        var code = this.responseCode() || "xxx";
        this.failWith({"errors":[`Sorry, an error occurred: ${code} ${textStatus} (${errorThrown})`]});
    }
};

/**
 * @return {number?}
 */
Foundation.API.prototype.responseCode = function () {
    return this._apiResponseCode
}

/**
 * @typedef {number}
 */
Foundation.API.RequestState = {
    WAIT: 0,
    SUCCESS: 1,
    APPLICATION_FAILURE: -1,
    TRANSPORT_FAILURE: -2
}

/**
 * @return {Foundation.API.RequestState}
 */
Foundation.API.prototype.requestState = function () {
    var responseCode = this.responseCode()
    if (responseCode === null) return Foundation.API.RequestState.WAIT
    if (responseCode >= 100 && responseCode < 400) return Foundation.API.RequestState.SUCCESS
    if (responseCode >= 400 && responseCode < 500) return Foundation.API.RequestState.APPLICATION_FAILURE
    return Foundation.API.RequestState.TRANSPORT_FAILURE
}

/**
 * @return {boolean}
 */
Foundation.API.prototype.requestFailedDueToTransportError = function () {
    return this.requestState() === Foundation.API.RequestState.TRANSPORT_FAILURE
}
